import { Breadcrumb } from '@magnetic/breadcrumb';
import { Button } from '@magnetic/button';
import { Flex } from '@magnetic/flex';
import { Heading } from '@magnetic/heading';
import { X } from '@magnetic/icons';
import React from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavDrawerHeading = /* @__PURE__ */ __name(({
  heading,
  onBackClick,
  ...rest
}) => {
  const { closeDrawer, goBack, shouldShowBack } = useNavContext();
  const handleBackClick = /* @__PURE__ */ __name((ev) => {
    goBack == null ? void 0 : goBack();
    onBackClick == null ? void 0 : onBackClick(ev);
  }, "handleBackClick");
  if (shouldShowBack) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "mds-nav-drawer-heading"
    }, /* @__PURE__ */ React.createElement(Flex, {
      direction: "vertical",
      gap: 8,
      justify: "space-between",
      ...rest
    }, /* @__PURE__ */ React.createElement(Breadcrumb, null, /* @__PURE__ */ React.createElement(Breadcrumb.Link, {
      onClick: handleBackClick,
      style: { cursor: "pointer" }
    }, "Back")), /* @__PURE__ */ React.createElement(Heading, {
      className: "mds-nav-drawer-heading-title line-clamp"
    }, heading)), /* @__PURE__ */ React.createElement(Button, {
      "aria-label": "Close drawer",
      className: "mds-nav-drawer-close-button",
      kind: "tertiary",
      onClick: closeDrawer,
      type: "button"
    }, /* @__PURE__ */ React.createElement(X, {
      className: "mds-nav-drawer-close-icon"
    })));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "mds-nav-drawer-heading"
  }, /* @__PURE__ */ React.createElement(Heading, {
    className: "mds-nav-drawer-heading-title line-clamp"
  }, heading), /* @__PURE__ */ React.createElement(Button, {
    "aria-label": "Close drawer",
    className: "mds-nav-drawer-close-button",
    kind: "tertiary",
    onClick: closeDrawer,
    type: "button"
  }, /* @__PURE__ */ React.createElement(X, {
    className: "mds-nav-drawer-close-icon"
  })));
}, "NavDrawerHeading");

export { NavDrawerHeading };
//# sourceMappingURL=heading.js.map
